/***
	errorCode (number) mapped to string message or to an object of format { message: [string message], timeout: [how long to show message, in seconds] }
	mapping to false will suppress the error message in the UI
***/
module.exports = {
	401: 'You can not view this assignment.',

	1024: 'Username email not found.',

	1015: 'Password is incorrect.',

	1062:
		'For security reasons we have disabled password recovery emails to your address due to a previous bounce or complaint. Please use our Feedback form to contact Customer Support to resolve this problem.',

	1064: {
		message:
			'Oops, it looks like your email has bounced! Visit our <a target="_blank" href="https://help.readworks.org/article/4-my-email-has-bounced-what-should-i-do">Support Center</a> so we can help resolve the issue.',
		timeout: 7
	},

	1091: {
		message: 'Sorry, your account has been suspended. Please tell your teacher.',
		timeout: 7
	},

	1027: 'Failed to send recovery email. This address is not in our records.',

	1050: 'Technical error.',

	1006: 'There is already an account using that email address. Please log in.',

	1023: 'Unknown Class Code.',

	1060: 'You cannot use your Google account with this class.',

	1029: "You have already assigned this article to this class. Please go to 'Assignments' to view or change the status of the existing assignment.",

	1055: 'This email address is already in use.',

	1059: 'You cannot have more than 200 students in one class.',

	1020: "You can't answer questions because you have already submitted the assignment.",

	1068: 'Your teacher has deleted this assignment.',

	1074: 'An error occurred while trying to reach Google, please try again.',

	1063: 'Please log in with Google again.',

	1075: 'This assignment is for one of your other classes.',

	1030: 'Sorry, this assignment is not available for your class.',

	1031: 'You have been removed from this class.',

	1026: 'Your account recovery token has expired, please request another one.',

	1077: false,

	1078: 'This article is not currently available. Please select another one.',

	1083: 'This class has been archived. See your teacher.',

	1056: 'Search unavailable.',

	1087: 'That co-teacher has already been added.',

	1088: 'There is no user with that email address. Please ask your colleague to sign up.',

	1089: "There's a problem with that account. Ask your colleague to confirm their ReadWorks account.",

	1090: false,

	1092: false,

	1093: 'Your Google account does not have permission to manage this class.',

	1094: "We can't delete this right now. Please archive it instead and try again next month.",

	1095: "This assignment has ended. You can 'Mark as Done' in Google Classroom.",

	1096: 'Sorry, please archive this class and re-import it from Google Classroom.',

	1097: 'Please update your ReadWorks class roster. Some students are not in Google Classroom.',

	1098: 'You have reached your invitation limit. Please try again later.',

	1099: 'Please use Clever to log in to ReadWorks.',

	1019: 'Tell your teacher to publish this assignment in the ReadWorks website.',

	1100: 'Sorry, but there is a problem with this assignment. Please delete it and create it anew.',

	1101: 'You have already confirmed your Co-Teacher invitation.',

	1105: 'Your account is a Clever account. Please login with Clever.',

	1110: 'Your account is a Google account. Please use "Sign in with Google."',

	1112: false,

	1113: 'Sorry, ReadWorks needs permission from Google to do that. Please re-authenticate your Google account.',

	1115: 'Sorry, this group does not exist. Please check the class roster.'
};
